<template>
  <div class="sidebar column" :class="{ 'collapsed': isCollapsed }">
    <div class="toggle-btn pointer v-center center" @click="isCollapsed = !isCollapsed">
      <img v-if="isCollapsed" src="~@/assets/images/icons/chevron-right.svg" width="12px" alt=">" />
      <img v-else src="~@/assets/images/icons/chevron-left.svg" width="12px" alt="<" />
    </div>

    <div class="logo-wrapper" @click="gotoDashboard">
      <img
        class="sidebar-brand-logo pointer"
        src="~@/assets/images/dtx-logo.svg"
        alt="DTX Logo"
      />
    </div>
    <div
      v-if="isCollapsed && activeTooltip"
      class="custom-sidebar-tooltip"
      :style="{ top: tooltipY + 'px' }"
    >{{ activeTooltip }}</div>

    <div class="nav-items-container" v-if="!(isBeaconAdmin || tenantType === 2)">
      <div class="nav-group">
        <router-link to="/forms" class="sidebar-btn" :class="{'active-page': currentPath === 'forms'}" @mouseenter.native="showTooltip($event, 'Forms')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/exam.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Forms</span>
        </router-link>

        <!-- <router-link to="/job-orders" class="sidebar-btn" :class="{'active-page': currentPath === 'job-orders'}" @mouseenter.native="showTooltip($event, 'MRP')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/icons/form-icon.svg" alt="" />
          <span v-if="!isCollapsed" class="btn-text">MRP</span>
        </router-link> -->

        <router-link @click.native="handleDocumentsLinkClick" to="/document-view" class="sidebar-btn" :class="{'active-page': currentPath === 'document-view'}" @mouseenter.native="showTooltip($event, 'Documents')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/file-text.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Documents</span>
        </router-link>

        <router-link v-if="!isOnFactoryLevel" :to="`/materialmaster/${1}`" class="sidebar-btn" :class="{'active-page': currentPath === 'materialmaster'}" @mouseenter.native="showTooltip($event, 'Item Master')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/product.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Item Master</span>
        </router-link>

        <router-link v-else :to="`/inventory`" class="sidebar-btn" :class="{'active-page': currentPath === 'inventory'}" @mouseenter.native="showTooltip($event, 'Inventory')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/product.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Inventory</span>
        </router-link>

        <router-link v-if="isOnProjectLevel && !isOnFactoryLevel" to="/bom/project" disabled class="sidebar-btn" :class="{'active-page': currentPath === 'bom', 'disabled-route' : restrictedRouting}" @mouseenter.native="showTooltip($event, 'BOM')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/structure.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">BOM</span>
        </router-link>
        <router-link v-else-if="!isOnFactoryLevel" to="/bom/product" class="sidebar-btn" :class="{'active-page': currentPath === 'bom',  'disabled-route' : restrictedRouting }" @mouseenter.native="showTooltip($event, 'BOM')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/structure.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">BOM</span>
        </router-link>

        <router-link v-if="!isOnFactoryLevel" to="/project-planner" class="sidebar-btn" :class="{'active-page': currentPath === 'project-planner'}" @mouseenter.native="showTooltip($event, 'Project Planner')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/gantt-chart.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Project Planner</span>
        </router-link>

        <router-link v-if="!isOnFactoryLevel" to="/timesheet/update" class="sidebar-btn" :class="{'active-page': currentPath === 'timesheet'}" @mouseenter.native="showTooltip($event, 'Time sheet')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/time-sheet.svg" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Time sheet</span>
        </router-link>
      </div>

      <div class="separator-wrapper">
        <div class="separator-line"></div>
      </div>
      <div class="nav-group">
        <div v-if="!isCollapsed" class="nav-section-header">DASHBOARDS</div>

        <router-link to="/trendsandforecast/material-forecast" class="sidebar-btn" v-if="showButtons && !isOnFactoryLevel" :class="{'active-page': currentPath === 'trendsandforecast'}" @mouseenter.native="showTooltip($event, 'Trends & Forecast')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/icons/forecast.svg" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Trends & Forecast</span>
        </router-link>

        <router-link v-if="!isOnFactoryLevel" :to="insightsEndpoint" class="sidebar-btn" :class="{'active-page': currentPath === 'insights'}" @mouseenter.native="showTooltip($event, 'Insights')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/pie-chart.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Insights</span>
        </router-link>

        <router-link v-if="!isOnFactoryLevel" to="/workflow-dashboard" class="sidebar-btn" :class="{'active-page': currentPath === 'workflow-dashboard'}" @mouseenter.native="showTooltip($event, 'WF Dashboard')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/workflow-dashboard.svg" alt="" />
          <span v-if="!isCollapsed" class="btn-text">WF Dashboard</span>
        </router-link>

        <router-link to="/item-master" class="sidebar-btn" :class="{'active-page': currentPath === 'item-master'}" @mouseenter.native="showTooltip($event, 'Items')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/items-icon.svg" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Items</span>
        </router-link>
      </div>

      <div class="separator-wrapper">
        <div class="separator-line"></div>
      </div>
      <div class="nav-group">
        <div v-if="!isCollapsed" class="nav-section-header">OPERATIONS</div>

        <router-link to="/factories" class="sidebar-btn" v-if="showFactoriesButton" :class="{'active-page': currentPath === 'factories'}" @mouseenter.native="showTooltip($event, 'Factories')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/factory-icon.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Factories</span>
        </router-link>

        <router-link to="/projects" class="sidebar-btn" v-if="showButtons && !isOnFactoryLevel && !isOnProjectLevel" :class="{'active-page': currentPath === 'projects'}" @mouseenter.native="showTooltip($event, 'Projects')" @mouseleave.native="hideTooltip">
          <img class="btn-icon icon-factories" src="~@/assets/images/project-management.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Projects</span>
        </router-link>

        <router-link to="/project" class="sidebar-btn" v-else-if="showButtons && !isOnFactoryLevel && isOnProjectLevel" :class="{'active-page': currentPath === 'project'}" @mouseenter.native="showTooltip($event, 'Project')" @mouseleave.native="hideTooltip">
          <img class="btn-icon" src="~@/assets/images/project-management.png" alt="" />
          <span v-if="!isCollapsed" class="btn-text">Project</span>
        </router-link>
      </div>
    </div>
    <div v-if="!(isBeaconAdmin || tenantType === 2)">
    <div class="separator-wrapper" v-if="showSettingButton">
      <div class="separator-line"></div>
    </div>

    <div class="sidebar-footer" v-if="showSettingButton">
      <router-link :to="settingsUrl" class="sidebar-btn btn-settings" :class="{'active-page': currentPath === 'settings'}" @mouseenter.native="showTooltip($event, 'Settings')" @mouseleave.native="hideTooltip">
        <img class="btn-icon" src="~@/assets/images/settings.svg" alt="" />
        <span v-if="!isCollapsed" class="btn-text">Settings</span>
      </router-link>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarComponent',
  data () {
    return {
      currentPath: '',
      isCollapsed: false,
      activeTooltip: null,
      tooltipY: 0,
      location: window.location.hostname
    }
  },
  computed: {
    ...mapGetters([
      'isBeaconAdmin',
      'isOnProjectLevel',
      'user',
      'collaborator',
      'tenantType',
      'openTenantId',
      'isOnFactoryLevel',
      'isFactorySupervisor',
      'openFactoryId'
    ]),
    settingsUrl () {
      if (this.isOnFactoryLevel) {
        const fId = this.openFactoryId || localStorage.getItem('factoryId')
        return fId ? `/${fId}/factory-settings` : '/factory-settings'
      }
      return '/settings/custom-list'
    },
    insightsEndpoint () {
      if (this.collaborator) return '/insights/product/personal'
      return this.isOnProjectLevel ? '/insights/project' : '/insights/product'
    },
    showSettingButton () {
      return (this.user.tenantLevelRole === 'ADMIN' || this.isOnFactoryLevel || this.user.tenantLevelRole === 'EDITOR' || this.user.tenantLevelRole === 'COLLABORATOR') && !this.collaborator
    },
    showFactoriesButton () { return !this.collaborator },
    showButtons () { return !this.collaborator },
    restrictedRouting () { return this.collaborator && this.$route.query.projectId }
  },
  methods: {
    gotoDashboard () {
      if (this.isOnFactoryLevel) this.$store.commit('exitFactory')
      this.$router.push('/')
    },
    handleDocumentsLinkClick () { this.$store.dispatch('fetchProjectList') },
    showTooltip (event, text) {
      if (!this.isCollapsed) return
      const rect = event.currentTarget.getBoundingClientRect()
      this.tooltipY = rect.top + (rect.height / 2) - 14
      this.activeTooltip = text
    },
    hideTooltip () {
      this.activeTooltip = null
    }
  },
  created () {
    this.currentPath = this.$route.path.split('/')[1].toLowerCase()
  },
  watch: {
    '$route.name' () {
      this.currentPath = this.$route.path.split('/')[1].toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.active-page {
  background-color: transparent !important;
  color: var(--brand-color) !important;
  font-weight: 600 !important;
  border-left: 4px solid var(--brand-color) !important;
  .btn-icon {
    filter: invert(68%) sepia(85%) saturate(388%) hue-rotate(1deg) brightness(92%) contrast(88%);
  }
}
.separator-wrapper {
  padding: 5px 15px;
  width: 100%;
}
.separator-line {
  height: 2px;
  background-color: #f0f0f0;
  width: 100%;
}
.custom-sidebar-tooltip {
  position: fixed;
  left: 65px;
  background: #ffffff;
  color: #000000;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: var(--text-xs1);
  font-weight: 400;
  white-space: nowrap;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1));
  z-index: 9999;
  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border: 5px solid transparent;
    border-right-color: #ffffff;
  }
}

.sidebar {
  height: 100vh;
  width: 170px;
  background-color: #ffffff;
  border-right: 1px solid #f0f0f0;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.02);
  z-index: 3;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;

  &.collapsed {
    width: 60px;
    .logo-wrapper { position: absolute; top: 0; left: 0; width: 60px; height: 60px; }
    .sidebar-brand-logo { width: 100% !important; height: 70% !important; }
    .sidebar-btn {
      justify-content: center;
      padding: 10px 0;
      gap: 0;
      border-left-width: 4px;
      .btn-icon {
        width: 20px;
      }
      .icon-items {
        width: 22px !important;
      }
      .icon-factories {
        width: 18px !important;
      }
    }
    .nav-items-container { margin-top: 35px; }
    .separator-wrapper { padding: 5px 10px; }
  }

  .toggle-btn {
    position: absolute;
    top: 45px;
    right: -12px;
    width: 24px;
    height: 24px;
    background-color: var(--side-bar-color);
    border-radius: 50%;
    color: white;
    z-index: 20;
    opacity: 0;
    transition: opacity 0.2s ease;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  }

  &:hover .toggle-btn { opacity: 1; }

  .logo-wrapper {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    margin: -4px;
    cursor: pointer;
    flex-shrink: 0;

    .sidebar-brand-logo {
      height: 70px;
      width: 70%;
      object-fit: fill;
      display: block;
    }
  }

  .nav-items-container {
    flex-grow: 1;
    width: 100%;
    overflow-y: auto;
    padding: 3px 0;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  .sidebar-footer {
    width: 100%;
    padding-bottom: 5px;
  }

  .nav-section-header {
    padding: 10px 20px;
    font-size: var(--text-xs2);
    font-weight: 700;
    color: #9e9e9e;
    text-transform: uppercase;
  }

  .sidebar-btn {
    padding: 7px 20px;
    color: #4a4a4a;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    width: 100%;
    border-left: 4px solid transparent;
    transition: all 0.2s ease;

    &:hover:not(.active-page) {
      background-color: transparent;
      color: var(--brand-color);
      border-left: 4px solid var(--brand-color);
      .btn-icon {
        filter: invert(68%) sepia(85%) saturate(388%) hue-rotate(1deg) brightness(92%) contrast(88%);
      }
    }

    .btn-icon {
      width: 18px;
      height: auto;
      transition: width 0.2s ease, filter 0.3s ease;
    }
    .icon-items {
      width: 22px;
    }
    .icon-factories {
      width: 18px;
    }
    .btn-text { font-size: 10.5px; font-weight: 400; white-space: nowrap; }
  }
  &:not(.collapsed) .btn-settings .btn-icon {
    width: 15px;
  }
  .disabled-route{
  pointer-events: none;
  cursor: pointer;
  }
}
</style>
